import { render, staticRenderFns } from "./StackOrderTable.vue?vue&type=template&id=39a1757e&"
import script from "./StackOrderTable.vue?vue&type=script&lang=ts&"
export * from "./StackOrderTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports